import { render, staticRenderFns } from "./BrowserTestTool.vue?vue&type=template&id=28ee04ae&scoped=true"
import script from "./BrowserTestTool.vue?vue&type=script&lang=js"
export * from "./BrowserTestTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee04ae",
  null
  
)

export default component.exports